import { ICommitmentException } from './RequirementsExceptionsService';

export class RequirementsExceptionsData {
  public B1: ICommitmentException[];
  public B2: ICommitmentException[];

  constructor(
    { B1, B2 } = {
      B1: [],
      B2: [],
    }
  ) {
    this.B1 = B1;
    this.B2 = B2;
  }
}
